import { Trans } from '@lingui/macro';
import { Divider, Flex, Switch } from '@mantine/core';
import { observer } from 'mobx-react-lite';

import { isStandalone } from '../../lib/detect';
import { isIOS } from '../../lib/detect/platforms';
import { usePushNotifyPerms } from './use-push-notify-perms';

export const PushNotifySettings = observer(() => {
  const [{ permState, isActive, isLoading }, { subscribe, unsubscribe }] =
    usePushNotifyPerms();

  const isNotSupported = permState.state === 'unsupported';
  const isDenied = permState.state === 'denied';
  const hasError = permState.state === 'error';

  if (isNotSupported && isIOS())
    return (
      <Trans>
        Для работы уведомлений необходимо добавить приложение на главный экран
        через меню на панели браузера
      </Trans>
    );

  if (isNotSupported)
    return <Trans>Ваше устройство не поддерживает Web Push уведомления</Trans>;

  if (isDenied && isIOS() && isStandalone())
    return (
      <Trans>
        В настройках вашего телефона запрещено показывать уведомления для этого
        приложения
      </Trans>
    );

  if (isDenied)
    return (
      <Trans>
        В настройках вашего браузера запрещено показывать уведомления для этого
        приложения
      </Trans>
    );

  return (
    <div>
      {hasError && (
        <>
          {permState.message} <Divider my={16} />
        </>
      )}

      <Flex justify="space-between">
        <Trans>Подписка на уведомления</Trans>
        <Switch
          checked={isActive}
          onChange={(event) => {
            const isActivate = event.currentTarget.checked;

            if (isActivate) {
              subscribe();
            } else {
              unsubscribe();
            }
          }}
          disabled={isLoading}
        />
      </Flex>
    </div>
  );
});
